import { render } from "./workInfo.vue?vue&type=template&id=16037ddc&scoped=true"
import script from "./workInfo.vue?vue&type=script&lang=js"
export * from "./workInfo.vue?vue&type=script&lang=js"

import "./workInfo.vue?vue&type=style&index=0&id=16037ddc&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16037ddc"]])

export default __exports__